import { apiRequest } from "./ApiUtility";
import axios from "./axios";

// Utility function to handle blob API requests with PDF viewing
async function blobApiRequest(method, url, authContext, data = null, options = {}) {
  const result = { isSuccess: false, data: {}, errorMessage: "" };
  
  if (!authContext) {
    result.errorMessage = "Authentication context is missing";
    return result;
  }

  try {
    const response = await axios({
      method,
      url,
      headers: {
        Authorization: `Bearer ${authContext.authToken}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      data,
      responseType: "blob",
    });
    
    result.isSuccess = true;
    
    // Handle PDF blob viewing
    if (options.openPDF) {
      const pdfBlob = new Blob([response?.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(pdfBlob);
      window.open(url);
    } else {
      result.data = response?.data;
    }
    
  } catch (error) {
    result.isSuccess = false;
    result.data = error?.response?.data;
  }

  return result;
}

export async function getPrescriptionsForService(auth, serviceId) {
  if (auth == null || serviceId == null) {
    return undefined;
  }
  
  const url = `/api/prescription/service/${serviceId}`;
  return await apiRequest("get", url, auth);
}

export async function getPrescriptionsForPatient(auth, patientId) {
  if (auth == null || patientId == null) {
    return undefined;
  }
  
  const url = `/api/prescription/patient/${patientId}`;
  
  // Note: Using auth.auth.authToken as in original code
  const modifiedAuthContext = {
    ...auth,
    authToken: auth.auth.authToken
  };
  
  return await apiRequest("get", url, modifiedAuthContext);
}

export async function getPrescription(auth, prescriptionId) {
  if (auth == null || prescriptionId == null) {
    return undefined;
  }
  
  const url = `/api/prescription/${prescriptionId}`;
  return await apiRequest("get", url, auth);
}

export async function viewPrescriptionById(auth, prescriptionId) {
  if (auth == null || prescriptionId == null) {
    return undefined;
  }
  
  const url = `/api/prescription/download/${prescriptionId}`;
  return await blobApiRequest("get", url, auth, null, { openPDF: true });
}

export async function addPrescription(
  authContext,
  prescription,
  serviceId,
  prescriptionType,
  status
) {
  const url = "/api/prescription";
  const data = {
    availedServiceId: serviceId,
    detailedPrescription: JSON.stringify(prescription),
    status: status,
    prescriptionType: prescriptionType,
  };
  
  // Using extended result structure with errorMessage
  const result = { isSuccess: false, data: {}, errorMessage: "" };
  
  if (!authContext) {
    result.errorMessage = "Authentication context is missing";
    return result;
  }

  try {
    const response = await axios({
      method: "post",
      url,
      headers: {
        Authorization: `Bearer ${authContext.authToken}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      data,
    });
    result.isSuccess = true;
    result.data = response?.data;
  } catch (error) {
    result.isSuccess = false;
    result.data = error?.response?.data;
  }

  return result;
}

export async function updatePrescription(
  authContext,
  prescription,
  prescriptionId,
  status
) {
  const url = `/api/prescription/${prescriptionId}`;
  const data = {
    detailedPrescription: JSON.stringify(prescription),
    status: status,
    facilityId: authContext.selectedFacility.id,
  };
  
  // Using extended result structure with errorMessage
  const result = { isSuccess: false, data: {}, errorMessage: "" };
  
  if (!authContext) {
    result.errorMessage = "Authentication context is missing";
    return result;
  }

  try {
    const response = await axios({
      method: "put",
      url,
      headers: {
        Authorization: `Bearer ${authContext.authToken}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      data,
    });
    result.isSuccess = true;
    result.data = response?.data;
  } catch (error) {
    result.isSuccess = false;
    result.data = error?.response?.data;
  }

  return result;
}

export async function removePrescription(authContext, prescriptionId) {
  const url = `/api/prescription/${prescriptionId}`;
  
  // Using extended result structure with errorMessage
  const result = { isSuccess: false, data: {}, errorMessage: "" };
  
  if (!authContext) {
    result.errorMessage = "Authentication context is missing";
    return result;
  }

  try {
    const response = await axios({
      method: "delete",
      url,
      headers: {
        Authorization: `Bearer ${authContext.authToken}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    result.isSuccess = true;
    result.data = response?.data;
  } catch (error) {
    result.isSuccess = false;
    result.data = error?.response?.data;
  }

  return result;
}